import { Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import '../modalDatosIniciales.css';
import ImportItemsPptos from '../../../imports/ImportItemsPptos';

export const DialogImports = ({ open, setOpen, detail }) => {

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
            fullScreen={true}
        >
            <div className='border-1 border-gray-300 m-3 rounded-2xl'>
                <IconButton
                    className='me-2 float-end'
                    aria-label="close"
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon />
                </IconButton>
                <ImportItemsPptos
                    open={open}
                    setOpen={setOpen}
                    detail={detail}
                />
            </div>
        </Dialog>
    )
}

